module.exports = __webpack_public_path__ + "static/images/play-with-oreo.1ba1dd6a8af106e66615817879538b9f.jpg";